import { ExamLiveCandidateDtoClient } from "@/api/live-exam/dto/exam-live-candidate.dto";
import { Badge } from "@/components/atoms/Badge";
import { Button } from "@/components/atoms/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/atoms/Dialog";
import { Input } from "@/components/atoms/Input";
import { ComboboxField } from "@/components/molecules/Combobox/Combobox";
import { socket } from "@/hooks/socket";
import { format, formatDate } from "date-fns";
import { Clock } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const HourDisplay = ({ date, text }: { date?: Date; text: string }) => (
  <div className="flex flex-col gap-1.5">
    <span>{text}</span>
    <Input
      name={text}
      disabled={true}
      value={date ? format(date, "HH:mm") : "-"}
    />
  </div>
);

interface FinishTimeDIalogProps {
  registration: ExamLiveCandidateDtoClient;
}

export const FinishTimeDIalog = ({
  registration: { candidate, examConnection, registration },
}: FinishTimeDIalogProps) => {
  const [minutesOffset, setMinutesOffset] = useState(0);
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);

  const onAcknowledge = (success: boolean) => {
    setPending(false);
    if (success) {
      setOpen(false);
      toast.success("Horaire de fin enregistré.");
    } else toast.error("Erreur lors de l'enregistrement de l'horaire de fin.");
  };

  return (
    <Dialog open={open} onOpenChange={(open) => setOpen(open)}>
      <DialogTrigger
        className="flex flex-row gap-2 items-center p-2 hover:bg-gray-50 transition-colors rounded-sm"
        onClick={(e) => e.stopPropagation()}
      >
        <Clock className="w-4 h-4" />
        <span>Modifier l'horaire de fin</span>
      </DialogTrigger>
      <DialogContent className="flex flex-col gap-6">
        <DialogHeader>
          <DialogTitle>
            {candidate.lastName} {candidate.firstName}
          </DialogTitle>
          <DialogDescription hidden={true}>
            Modification horaire de fin
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <div className="flex flex-row gap-4">
            <span className="text-black">Périmètre de l'examen</span>
            <Badge variant="white">{registration.perimeter}</Badge>
          </div>
          <HourDisplay
            text="Première connexion"
            date={examConnection?.connectedAt[0]}
          />
          <HourDisplay
            text="Horaire de fin actuel"
            date={examConnection?.plannedFinishTime}
          />
          <div className="flex flex-col gap-1.5">
            <label htmlFor="finishTime">Nouvel horaire de fin</label>
            <ComboboxField
              options={Array.from({ length: 120 }, (_, i) => {
                const minutesOffset = (i - 60) * 5;
                const date = new Date(
                  new Date().getTime() + 1000 * 60 * minutesOffset
                );

                return {
                  value: minutesOffset,
                  label: formatDate(date, "HH:mm"),
                };
              })}
              placeholder="-"
              value={minutesOffset}
              onChange={setMinutesOffset}
              id="finishTime"
              displaySearchBox={false}
            />
          </div>
          <Button
            onClick={() => {
              setPending(true);
              socket.emit(
                "finishTime",
                {
                  registrationId: registration.id,
                  finishTime: new Date(
                    new Date().getTime() + 1000 * 60 * minutesOffset
                  ),
                },
                onAcknowledge
              );
            }}
            disabled={pending}
          >
            {pending ? "En cours..." : "Valider le nouvel horaire de fin"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FinishTimeDIalog;
